import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { StandardNameUpdateStateService } from './standard-name-update-state.service';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class StandardNameUpdateGuard implements CanActivate {

  private updateState = inject(StandardNameUpdateStateService);
  private router = inject(Router);
  private messageService = inject(MessageService);

  canActivate(): boolean {
    if (this.updateState.updatesInProgress()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Sökning ej tillgänglig',
        detail: 'Sökning ej tillgänglig , Uppdatering av standardnamn pågår för närvarande.',
        styleClass: 'standard-name-toast',
        sticky: true
      });
      return false;
    }
    return true;
  }
}
